/** Строка итогов по полному списку Telegram-аккаунтов (KAN-614). */
import type { AccountsSummaryData } from '@/lib/telegramAccountList';

interface AccountsSummaryProps {
  summary: AccountsSummaryData;
  /** Сколько показано при активном фильтре; undefined: фильтр не активен. */
  shown?: number;
  /** Знаменатель подписи "показано"; по умолчанию summary.total. */
  shownOf?: number;
}

function Item({ id, label, value }: { id: string; label: string; value: number }): JSX.Element {
  return (
    <span className="text-gray-600">
      {label}:{' '}
      <span data-testid={id} className="font-semibold text-gray-900">
        {value}
      </span>
    </span>
  );
}

export function AccountsSummary({ summary, shown, shownOf }: AccountsSummaryProps): JSX.Element {
  return (
    <div
      data-testid="accounts-summary"
      className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm"
    >
      <Item id="summary-total" label="Всего" value={summary.total} />
      <Item id="summary-enabled" label="Включены" value={summary.enabled} />
      <Item id="summary-outreach" label="Пишут первыми" value={summary.outreach} />
      <Item id="summary-disabled" label="Выключены" value={summary.disabled} />
      <Item id="summary-problem" label="Проблемные" value={summary.problem} />
      <Item id="summary-decommissioned" label="Списанные" value={summary.decommissioned} />
      <Item id="summary-healthy" label="Здоровых" value={summary.healthy} />
      <Item id="summary-connected" label="всего подключено" value={summary.connected} />
      <Item id="summary-flooded" label="были под флудом" value={summary.flooded} />
      {shown !== undefined && (
        <span data-testid="accounts-shown" className="text-gray-500">
          показано {shown} из {shownOf ?? summary.total}
        </span>
      )}
    </div>
  );
}
